import React from "react"
import "./menu.module.scss"

const HamburgerIcon = () => {
  return (
    <>
      <div className={`menu-icon`}>
        <span id="top" className="menu-icon__bar"></span>
        <span id="middle" className="menu-icon__bar"></span>
        <span id="bottom" className="menu-icon__bar"></span>
      </div>
    </>
  )
}

export default HamburgerIcon
